import { Check } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { PRICING_TIERS } from "@/data/site";

const Pricing = () => (
  <section
    id="pricing"
    data-testid="pricing-section"
    className="scroll-mt-24 bg-white py-24 md:py-32 lg:py-40"
  >
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <SectionHeading
        align="center"
        overline="Pricing"
        title="Engagements Shaped Around Your Goals"
        text="Every project is different. Contact us for a tailored proposal."
      />

      <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {PRICING_TIERS.map((tier, i) => (
          <Reveal key={tier.name} delay={i * 0.1} className="h-full">
            <div
              data-testid={`pricing-tier-${tier.name.toLowerCase()}`}
              className={`relative flex h-full flex-col rounded-2xl p-8 transition-[box-shadow,transform] duration-500 hover:-translate-y-1 ${
                tier.featured
                  ? "noise-overlay overflow-hidden bg-navy-950 shadow-2xl hover:shadow-[0_24px_60px_-16px_rgba(5,10,31,0.5)]"
                  : "border border-slate-200 bg-white shadow-sm hover:shadow-xl"
              }`}
            >
              {tier.featured && (
                <span className="absolute right-6 top-6 rounded-full bg-electric px-3.5 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-white">
                  Most Popular
                </span>
              )}
              <h3
                className={`font-display text-2xl font-medium ${
                  tier.featured ? "text-white" : "text-slate-900"
                }`}
              >
                {tier.name}
              </h3>
              <p
                className={`mt-3 text-sm leading-relaxed ${
                  tier.featured ? "text-slate-400" : "text-slate-600"
                }`}
              >
                {tier.tagline}
              </p>
              <p
                className={`mt-6 text-xs font-semibold uppercase tracking-[0.18em] ${
                  tier.featured ? "text-electric-bright" : "text-electric"
                }`}
              >
                Suitable for
              </p>
              <ul className="mt-4 flex-1 space-y-3">
                {tier.features.map((feature) => (
                  <li
                    key={feature}
                    className={`flex items-start gap-2.5 text-sm ${
                      tier.featured ? "text-slate-300" : "text-slate-700"
                    }`}
                  >
                    <Check
                      className={`mt-0.5 h-4 w-4 shrink-0 ${
                        tier.featured ? "text-cyan-400" : "text-electric"
                      }`}
                      strokeWidth={2}
                    />
                    {feature}
                  </li>
                ))}
              </ul>
              <a
                href="#contact"
                data-testid={`pricing-cta-${tier.name.toLowerCase()}`}
                className={`mt-8 inline-flex items-center justify-center rounded-full px-7 py-3.5 text-sm font-medium transition-[background-color,box-shadow,transform,border-color] duration-300 active:scale-95 ${
                  tier.featured
                    ? "bg-electric text-white hover:scale-[1.02] hover:bg-electric-bright hover:shadow-[0_0_24px_rgba(37,99,235,0.5)]"
                    : "border border-slate-300 text-slate-800 hover:border-electric hover:text-electric"
                }`}
              >
                {tier.cta}
              </a>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-10 text-center text-sm text-slate-500" data-testid="pricing-note">
          Every project is different. Contact us for a tailored proposal.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Pricing;
